<template>
	<div class="commer-content box-sizing userList">
		<div class="commer-list">
			<p class="commer-list-title">
				系统管理>用户列表
			</p>
			<div class="commer-list-export-box">
				<span>共查询到{{totals}}个结果</span>
				<div class="right-add">
				  <el-button type="info" icon="el-icon-plus" @click='operation(1,"")'>新增</el-button>
			   </div>
			</div>
			<div class="table-list">
				<el-table
					:data="tableList"
					border
					style="width: 100%">
					<el-table-column
						type="index"
						label="序号"
						width="70">
					</el-table-column>
					<el-table-column
						prop="username"
						label="用户名">
					</el-table-column>
					<el-table-column
						prop="companyName"
						label="姓名">
					</el-table-column>
					<el-table-column
					prop="mobile"
					label="联系方式">
					</el-table-column>
					<el-table-column
					prop="status"
					label="是否启用">
					<template slot-scope="scope">
							<span v-for="item in statusList" v-if="item.value==scope.row.status">{{item.lable}}</span>
					</template>
					</el-table-column>
					<el-table-column
					prop="createDate"
					label="创建时间">
					<template slot-scope="scope">
						<span>{{scope.row.createDate | dateFormat }}</span>
					</template>
					</el-table-column>
					<el-table-column
						label="操作"
						width="180">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click='operation(2,scope.row.id)'>编辑</el-button>
							<el-button type="text" size="small"  @click='ifDelete(scope.row.id)'>删除</el-button>
							<el-button type="text" size="small"  @click='ifchangPsw(scope.row.id)'>修改密码</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pages">
				<el-pagination
					@current-change="handleCurrentChange"
					:current-page="getListParams.pageNo"
					:page-size="getListParams.pageSize"
					layout="total, prev, pager, next, jumper"
					:total="totals">
				 </el-pagination>
		   </div>
		</div>
		<el-dialog
		:title="titleMsg"
		:visible.sync="ifAdd"
		:modal-append-to-body='false'
		width='30%'>
		<el-form :model="addParams" ref="addParams" label-width="100px" class="demo-ruleForm" :rules="rules">
			<div style="display:flex;margin-bottom:10px;">
				<span class="LOGO">用户头像</span>
				<photo-upload :imgList='addParams.headImage' @uploadImg='uploadImg'></photo-upload>
			</div>
			<el-form-item label="用户名" prop="username">
				<el-input v-model="addParams.username" placeholder="请输入用户名"></el-input>
			</el-form-item>
			<el-form-item label="公司名称" prop="companyName">
				<el-input v-model="addParams.companyName" placeholder="请输入公司名称"></el-input>
			</el-form-item>
			<!-- <el-form-item label="所属公司" prop="companyId">
				<el-select v-model="addParams.companyId" placeholder="请选择状态" @change='compenyChange'>
					<el-option
						v-for="item in companyList"
						:key="item.id"
						:label="item.name"
						:value="item.id">
					</el-option>
					<el-option :value="values" label='不限'></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="所属项目" prop="projectId">
				<el-select v-model="addParams.projectId" placeholder="请选择状态">
					<el-option
						v-for="item in projectList"
						:key="item.id"
						:label="item.name"
						:value="item.id">
					</el-option>
					<el-option :value="values" label='不限'></el-option>
				</el-select>
			</el-form-item> -->
			<el-form-item label="手机号码" prop="mobile">
				<el-input v-model="addParams.mobile" placeholder="请输入手机号码"></el-input>
			</el-form-item>
			<el-form-item label="职位" prop="position">
				<el-input v-model="addParams.position" placeholder="请输入职位"></el-input>
			</el-form-item>
			<el-form-item label="状态" prop="status">
				<el-select v-model="addParams.status" placeholder="请选择状态">
					<el-option
						v-for="item in statusList"
						:key="item.value"
						:label="item.lable"
						:value="item.value">
					</el-option>
					<!-- <el-option value="0" label='11'>11</el-option> -->
				</el-select>
			</el-form-item>
			<el-form-item label="角色">
				<el-checkbox-group v-model="addParams.roles">
					<el-checkbox  name="type" v-for="item in roleList" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="ifAdd = false">取 消</el-button>
			<el-button type="primary" @click="save('addParams')">保 存</el-button>
		</span>
		</el-dialog>
		<el-dialog
			title="提示"
			:visible.sync="ifDeleteBox"
			:modal-append-to-body='false'
			width="30%">
			<span class="ifDetetes">是否删除</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="ifDeleteBox = false">取 消</el-button>
				<el-button type="primary" @click="sureDelete">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog
			title="修改密码"
			:visible.sync="showPsw"
			:modal-append-to-body='false'
			width="30%">
			<div>
				<p style="margin-bottom:20px;"><span style="display: inline-block;width: 15%;">新密码</span><el-input v-model="pswOne" placeholder="请输入密码" style="width:80%;" type='password'></el-input></p>
				<p><span style="display: inline-block;width: 15%;">确认密码</span><el-input v-model="pswTwo" placeholder="请确认密码" style="width:80%;"  type='password'></el-input></p>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showPsw = false">取 消</el-button>
				<el-button type="primary" @click="sureChangePsw">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	import PhotoUpload from  '@/components/public/photoUpload.vue' 
	export default{
		data(){
			return{
				input:'',
				status:'',
				ifAdd:false,
				statusList:[
					{
						lable:"启用",
						value:1
					},{
						lable:"禁用",
						value:0
					}
				],
				tableList: [],
				page:1,
				limit:2,
				name:'',
				getListParams:{
					pageNo:1,
					pageSize:10,
				},
				totals:1,
				operationStatus:'',
				companyID:'',
				addParams:{
					headImage:'',
					username:'',
					realName:'',
					gender:0,
					mobile:'',
					status:1,
					roles:[],
					companyId:'',
					projectId:'',
					companyName:'',
					position:''
				},
				sexList:[
					{
						value:0,
						label:'女'
					},
					{
						value:1,
						label:'男'
					}
				],
				titleMsg:'新增',
				ifAdd:false,
				rules:{
					username:[{required: true,message: '请输入 用户名'}],
					status:[{required: true,message: '请选择状态'}],
					companyId:[{required: true,message: '请选择公司'}],
					projectId:[{required: true,message: '请选择项目'}]
				},
				ifDeleteBox:false,
				roleList:[],
				companyList:[],
				projectList:[],
				values:0,
				userId:'',
				showPsw:false,
				pswOne:'',
				pswTwo:''
			}
		},
		mounted(){
			var vm=this;
			vm.getList()
			//获取角色列表
			vm.$http.get('/api/console/sysUser/queryRoleList')
			.then(function(response){
				
				vm.roleList=response.data
			
			})
			// vm.$http.get('/api/getCompanyList',{params:{'name':''}})
			// .then(function(response){
			// 	vm.companyList=response.data
			// })
		},
		methods:{
			//分页
			handleCurrentChange:function(val){
				this.getListParams.pageNo=val;
				this.getList()
			},
			getList:function(){
				var vm=this;
				vm.$http.get('/api/console/sysUser/queryPage',
					{params:vm.getListParams}
				)
				.then(function(response){
					
					vm.tableList=response.data.items
					vm.totals=parseInt(response.data.page.rowCount)*1
				})
			},
			//出现新增框
			operation:function(operationStatus,companyID){
				var vm=this;
				this.operationStatus=operationStatus
				this.ifAdd=true
				if(operationStatus==1){
					vm.titleMsg='新增'
					vm.addParams={
						headImage:'',
						username:'',
						realName:'',
						gender:'',
						mobile:'',
						status:1,
						roles:[],
						companyId:'',
						projectId:'',
						companyName:'',
						position:''
					}
					// if(vm.companyList&&vm.companyList.length>0){
					// 	vm.addParams.companyId=vm.companyList[0].id
					// 	vm.compenyChange()
					// }

				}else{
					vm.titleMsg='编辑'
					vm.$http.get('/api/console/sysUser/query',{
					   params:{
							 id:companyID
						 }
					})
					.then(function(response){
						let resTemp=response.data[0]
						resTemp.roles=[]
						let tepRoleids=response.data[1]
						
						for(var i in resTemp){
							if(i=='updateDate'||i=='createDate'){
								delete resTemp[i]
							}
						}
						if(tepRoleids.length>0){
							tepRoleids.forEach((res)=>{
								resTemp.roles.push(res.rid)
							})
						}else{
							resTemp.roles=[]
						}
						vm.addParams=resTemp
						// vm.$http.get('/api/getProjectList',{params:{'name':'',companyId:vm.addParams.companyId}})
						// .then(function(response){
						// 	vm.projectList=response.data
							
						// })
						

					})
					
				
				}
			},
			//是否删除数据
			ifDelete:function(companyID){
				this.companyID=companyID
				this.ifDeleteBox=true
			},
			//确认删除
			sureDelete:function(){
				var vm=this;
				vm.$http.post('/api/console/sysUser/delete',{ids:vm.companyID})
				.then(function(response){
					if(response.code==0){
						
						vm.$message({
							message: '删除成功',
							type: 'success'
						});
						vm.ifDeleteBox=false
						vm.getList()
					}
						
				})
			},
			//上传图片
			uploadImg:function(val){
				this.$set(this.addParams,"headImage",val)
		
			},
			compenyChange:function(){
				var vm=this;
				vm.addParams.projectId=''
				vm.$http.get('/api/getProjectList',{params:{'name':'',companyId:vm.addParams.companyId}})
				.then(function(response){
					vm.projectList=response.data
					if(vm.projectList&&vm.projectList.length>0){
						vm.addParams.projectId=vm.projectList[0].id
					}else{
						vm.addParams.projectId=''
					}
					
                    
                })
			},
			//保存数据
			save:function(formName){
				
				var vm=this;
				vm.$refs[formName].validate((valid) => {
					if (valid) {
						var tepParams=vm.addParams
						var tepParamsId=''
						if(tepParams.roles.length>0){
							tepParams.roles.forEach(function(res){

								tepParamsId=tepParamsId==''?res:tepParamsId+','+res
							})
						}
						tepParams.roles=tepParamsId
						
						vm.$http.post('/api/console/sysUser/save',tepParams)
						.then(function(response){
							if(response.code==0){
								vm.$message({
									message: '保存成功',
									type: 'success'
								});
								vm.ifAdd=false;
								vm.getList()
							}
						})
					}
				})

				
			},
			//修改密码
			ifchangPsw:function(id){
				this.pswOne=''
				this.pswTwo=''
				this.showPsw=true
				this.userId=id
			},
			//确认更改
			sureChangePsw:function(){
				var vm=this;
				if(vm.pswOne===vm.pswTwo){
					vm.$http.post('/api/console/sysUser/updatePassword',{
						userId:vm.userId,
						newpwd:vm.pswOne,
						confirm:vm.pswTwo
					})
					.then(function(response){
						if(response.code==0){
							vm.$message({
								message: '修改成功',
								type: 'success'
							});
							vm.showPsw=false;
							vm.getList()
						}
						
					})
				}else{
					vm.$message({
						message: '两次密码不一致，请重新输入',
						type: 'error'
					});
				}
			}
		},
		components:{
			PhotoUpload,
		}
	}
</script>
<style lang="less" scoped='scoped'>
	.userList{
		
		.LOGO{
			width: 100px;
			text-align: right;
			line-height: 60px;
			margin-right: 20px;
		}
	}

</style>


// WEBPACK FOOTER //
// src/views/systemSetup/userList.vue